import React from "react";
import { useMediaQuery } from "@mui/material";
import UiFormControlSelection from "../../common/ui/UiFormControlSelection";
import UiFormField from "../../common/ui/UiFormField";
import { ERRORS } from "../../constants/user-info.const";

export default function PersonalInfoForm() {
  const ssnMask = "000-00-0000";
  const ssnDefinition = /[0-9]/;
  const smDevice = useMediaQuery("(max-width:600px)");
  const returnDatePicker = () => {
    if (!smDevice) {
      return (
        <UiFormControlSelection
          label="Date of Birth (Required)"
          type="date"
          fieldName="date_of_birth"
          dateType="string"
          errorMessage={ERRORS.dob}
          maxDate={new Date()}
          showFloatingLabel={true}
          placeholder="MM/DD/YYYY"
          labelClass="date-picker"
        />
      );
    }
    return (
      <UiFormControlSelection
        label="Date of Birth (Required)"
        type="dateMobile"
        fieldName="date_of_birth"
        dateType="string"
        errorMessage={ERRORS.dob}
        maxDate={new Date()}
        showFloatingLabel={true}
        dateFormat="dd/MM/yyyy"
        placeholder="DD/MM/YYYY"
        labelClass="date-picker"
      />
    );
  };
  return (
    <>
      <UiFormField
        type="text"
        placeholder="First Name (Required)"
        label="First Name (Required)"
        labelSize={false}
        fieldName="first_name"
        maxLength={64}
        showFloatingLabel={true}
      />
      <UiFormField
        type="text"
        placeholder="Middle Name (Optional)"
        label="Middle Name (Optional)"
        labelSize={false}
        fieldName="middle_initial"
        maxLength={64}
        showFloatingLabel={true}
      />
      <UiFormField
        type="text"
        placeholder="Last Name (Required)"
        label="Last Name (Required)"
        fieldName="last_name"
        labelSize={false}
        maxLength={64}
        showFloatingLabel={true}
      />
      <UiFormField
        type="text"
        placeholder="Email (Required)"
        label="Email (Required)"
        labelSize={false}
        fieldName="email"
        maxLength={254}
        showFloatingLabel={true}
      />

      <div className="personal-info--containerSmall">
        {returnDatePicker()}
        <UiFormField
          type="mask"
          placeholder="Hidden"
          label="Social Security Number"
          fieldName="ssn"
          mask={ssnMask}
          definitions={ssnDefinition}
          minLength={9}
          labelSize={false}
          showFloatingLabel={true}
          helperText={
            "For security purposes your SSN has been hidden. You can update it by typing in the field."
          }
        />
      </div>
    </>
  );
}
